import React from 'react';
import { AppService } from '@aperza/util';
const appConfig = AppService.appConfig();
export default class FooterSocialLinks extends React.Component {
    render() {
        return (React.createElement("ul", { className: "strip footer-social-links", style: { justifyContent: 'space-between' } },
            React.createElement("li", null,
                React.createElement("a", { className: "sns-fb", href: `https://www.facebook.com/news.aperza/` },
                    React.createElement("i", { className: "fa fa-facebook-square" }))),
            React.createElement("li", null,
                React.createElement("a", { className: "sns-ins", href: `https://www.instagram.com/monozukuri_news/` },
                    React.createElement("i", { className: "fa fa-instagram" }))),
            React.createElement("li", null,
                React.createElement("a", { className: "sns-tw", href: `https://twitter.com/news_aperza` },
                    React.createElement("i", { className: "fa fa-twitter" }))),
            React.createElement("li", null,
                React.createElement("a", { className: "sns-yt", href: `https://www.youtube.com/channel/UCEPoZF8KKr2Hm0QiBympWOA/videos` },
                    React.createElement("i", { className: "fa fa-youtube-play" })))));
    }
}
